import axiosPlataformaClient from '../../plugins/axios.plataforma.plugin';
import queryString from 'query-string';

export default {
  getCategories() {
    return axiosPlataformaClient.custAxios().get('academic/calendar/category');
  },
  getAppointments({ initialDate, endDate, appointmentCategories, academicMainIds, courseCategoryIds }) {
    const stringified = queryString.stringify({ initialDate, endDate, appointmentCategories, academicMainIds, courseCategoryIds }, { skipNull: true, skipEmptyString: true });
    return axiosPlataformaClient.custAxios().get(`academic/calendar/appointment${stringified && `?${stringified}`}`);
  },
  getAppointmentById(id) {
    return axiosPlataformaClient.custAxios().get(`academic/calendar/appointment/${id}`);
  },
  createAppointment({ title, description, startAt, endAt, academicMainIds, courseCategoryIds, appointmentCategoryId, isAllDay, webconferenceSettings }) {
    return axiosPlataformaClient.custAxios().post('academic/calendar/appointment', {
      title,
      description,
      startAt,
      endAt,
      academicMainIds,
      courseCategoryIds,
      appointmentCategoryId,
      isAllDay,
      webconferenceSettings
    });
  },
  editAppointment({ id, title, description, startAt, endAt, academicMainIds, courseCategoryIds, appointmentCategoryId, isAllDay, webconferenceSettings }) {
    return axiosPlataformaClient.custAxios().put(`academic/calendar/appointment/${id}`, {
      title,
      description,
      startAt,
      endAt,
      academicMainIds,
      courseCategoryIds,
      appointmentCategoryId,
      isAllDay,
      webconferenceSettings
    });
  },
  deleteAppointment(id) {
    return axiosPlataformaClient.custAxios().delete(`academic/calendar/appointment/${id}`);
  }
}
;
